import { authenticateByAuthorizationToken } from '../api/authentication';

export const authenticateByToken = (token: string): Promise<void> =>
  authenticateByAuthorizationToken(token);
